import * as ApiNames from '../../constants/ApiNames';
const apiNameSet = new Set(Object.values(ApiNames));
export const isApiName = name => {
  return apiNameSet.has(name);
};